import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})

export class AppState {

    private companyInfoSub$ = new BehaviorSubject<any>(null);
    companyInfo$ = this.companyInfoSub$.asObservable();

    public get companyInfoValue() {
        return this.companyInfoSub$.value;
    }

    public set companyInfoValue(value) {
        this.companyInfoSub$.next(value);
    }
}